import { render } from "./StatisticCounterparties.vue?vue&type=template&id=6fdd2f1c&ts=true"
import script from "./StatisticCounterparties.vue?vue&type=script&lang=ts"
export * from "./StatisticCounterparties.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__